import { UPDATE_AIRPLANES } from "../constants";

export default (state = [], action) => {
  switch (action.type) {
    case UPDATE_AIRPLANES:
      return [...action.payload];
    default:
      return state;
  }
};
